/**
 * Marker that allows us to track usage of hidden foundations-components props.
 *
 * @example
 * <Select ignoreCase={asHiddenProp(false)} />
 */
export function asHiddenProp(x) {
  return x;
}